var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.hideResolvedComments ? 'green' : 'black',"outlined":""},on:{"click":function($event){return _vm.toggleResolvedComments(!_vm.hideResolvedComments)}}},[_vm._v(" Hide Resolved ")])}
var staticRenderFns = []

export { render, staticRenderFns }